import React, { useEffect } from "react"
import "../styles/Profile.css"
import saved from "../images/saved.png"
import shop from "../images/cart.png"
import cart from "../images/shop.png"
import settings from "../images/settings.png"
import comment from "../images/comment.png"
import like from "../images/like.png"
import next from "../images/next.png"
import prev from "../images/prev.png"
import { Link, Outlet } from "react-router-dom"
import { useLocation, NavLink } from 'react-router-dom';

import { useState } from "react"
import { IconButton, useMediaQuery } from "@mui/material"

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ShopIcon from '@mui/icons-material/Shop';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SettingsIcon from '@mui/icons-material/Settings';
export default function Profile(){
      
  const profileArray = [
    {
        route: "",
        title: "Profile",
        icon: <AccountCircleIcon style={{fontSize:"20px"}} />
    },
    {
        route: "shop",
        title: "Shops",
        icon: <ShopIcon style={{fontSize:"20px"}} />
    },
   
    {
        route: "savedPost",
        title: "Saved Post",
        icon: <BookmarkIcon style={{fontSize:"20px"}} />
    },
    {
        route: "setting",
        title: "Settings",
        icon: <SettingsIcon style={{fontSize:"20px"}} />
    },
]


let [minimize,HandleMinimize]=useState(false)
const matches = useMediaQuery('(max-width:800px)');

useEffect(()=>{
    HandleMinimize(true)
},[matches])
 return (
        <div className="whole-profiles-container">
            <div className={`profiles-link-container ${minimize&&"profiles-link-container-minimized"}`}>
            {
                profileArray.map((item, index) => {
                    return ( <>  <EachProfileLink minimize={minimize}  key={index} item={item}/> </>
                    )
                })
            }
             {!matches&&<div className="profiles-link-container-minimize-button"><IconButton onClick={()=>HandleMinimize(!minimize)}>{minimize?<ArrowForwardIosIcon/>:<ArrowBackIosNewIcon/>}</IconButton></div>}
            </div>
            
            <div className="profiles-routes">
                <Outlet />
            </div>
        </div>
    )
}


const EachProfileLink = ({ item,minimize }) => {
    
    const location = useLocation();
    const [routes, setRoutes] = useState(location.pathname.split('/'));
    const [active, setActive] = useState(item.route === routes[2]);
  
    useEffect(() => {
        let currntRoute=location.pathname.split('/')
        if(currntRoute.length===2&&item.route===""){
            setActive('profile' === currntRoute[1]);
        }
        else{
            setActive(item.route === currntRoute[2]);

        }
    }, [location, routes]);
  
    return (
      <NavLink
        className={(active) ? `each-profile-component ${minimize?"acitve-minimized":"active"} ${minimize&&"each-profile-component-minimized"}` : `each-profile-component ${minimize&&"each-profile-component-minimized"}`}
        to={`/profile/${item.route}`} // Update the route structure here
      >
         <div >{item.icon}</div>
        {!minimize&&<div>{item.title}</div>}
      </NavLink>
    );
  };

